import { render, staticRenderFns } from "./CollectionsInput.vue?vue&type=template&id=3d036d32&"
import script from "./CollectionsInput.vue?vue&type=script&lang=ts&"
export * from "./CollectionsInput.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsInput.vue?vue&type=style&index=0&id=3d036d32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports